<p>dashboard works!</p>

<button type="button" class="btn login_btn" (click)="authService.signOut()">
    Sign Out
  </button>
